import { useQuery } from '@tanstack/react-query';
import {
  EInvoiceAccountsService,
  ListHiloAccountsEntity,
} from 'services/openapi';

import { EInvoiceAccountQueryKeys } from './constants';
import { isEmpty } from 'lodash';

type GetEInvoiceAccountListQueryVariables = {
  page: number;
  pageSize: number;
};

export const useGetEInvoiceAccountListQuery = (
  variables: GetEInvoiceAccountListQueryVariables,
) => {
  const queryKey = [
    EInvoiceAccountQueryKeys.GET_EINVOICE_ACCOUNT_LIST,
    variables,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<ListHiloAccountsEntity, Error>({
    queryKey,
    queryFn: () =>
      EInvoiceAccountsService.einvoiceAccountControllerListHiloAccounts(
        String(variables.page),
        String(variables.pageSize),
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: false,
    enabled: !isEmpty(variables),
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
